"use strict";

exports.__esModule = true;
exports.default = isReady;

function isReady() {
  return typeof window !== "undefined" && typeof window.grecaptcha !== "undefined" && typeof window.grecaptcha.execute !== "undefined";
}